import { render, staticRenderFns } from "./UserCoworkers.vue?vue&type=template&id=519296fc&"
import script from "./UserCoworkers.vue?vue&type=script&lang=js&"
export * from "./UserCoworkers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports